import { StylesConfig } from 'react-select';
import { BouColor } from '../global/bou-colors';

const active = '#141414';
const passive = BouColor.GREY_B3B3B3;

// https://react-select.com/styles
export const inlineSelectStyles: StylesConfig<any> = {
  container: base => ({
    ...base,
    letterSpacing: 0,
  }),
  control: (base, state) => ({
    ...base,
    background: '#ffffff',
    borderRadius: 1,
    borderWidth: 1,
    borderColor: state.isFocused ? active : passive,
    '&:hover': {
      borderColor: state.isFocused ? active : passive,
    },
    transition: 'border-color 0.12 ease-in-out',
    boxShadow: 'none',
    display: 'flex',
    minHeight: '2.2em',
    cursor: 'pointer',
  }),
  placeholder: (base, state: { isFocused: boolean }) => ({
    ...base,
    color: '#888888',
    display: state.isFocused ? 'none' : 'block',
    fontWeight: 'normal',
  }),
  clearIndicator: base => ({
    ...base,
    cursor: 'pointer',
  }),
  singleValue: base => ({
    ...base,
    paddingRight: '8px',
    color: active,
    backgroundColor: 'transparent',
    cursor: 'pointer',
  }),
  menu: base => ({
    ...base,
    border: `1px solid ${active}`,
    borderRadius: '1px',
  }),
  option: (base, state: { isFocused: boolean; isSelected: boolean }) => ({
    ...base,
    fontWeight: state.isSelected ? 'bold' : undefined,
    color: state.isFocused && !state.isSelected ? passive : active,
    backgroundColor: 'transparent', // override
    cursor: 'pointer',
  }),
};
